import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Save, RotateCcw, Search } from "lucide-react";
import { toast } from "sonner";

export default function AdminCMS() {
  const [blocks, setBlocks] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/cms/blocks"); setBlocks(data.blocks || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async (key) => {
    try { await api.put(`/admin/cms/blocks/${encodeURIComponent(key)}`, { value: drafts[key] }); toast.success(`Saved ${key}`); await load(); setDrafts((d) => { const c = { ...d }; delete c[key]; return c; }); }
    catch { toast.error("Save failed"); }
  };
  const reset = async (key) => {
    if (!window.confirm(`Reset ${key} to default?`)) return;
    try { await api.delete(`/admin/cms/blocks/${encodeURIComponent(key)}`); toast.success("Reset"); await load(); }
    catch { toast.error("Reset failed"); }
  };

  const filtered = blocks.filter((b) => !q || b.key.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-cms">
      <div className="dms-label mb-3">CMS</div>
      <h1 className="text-2xl sm:text-3xl font-heading font-bold text-[#0A2342]">Site copy & content</h1>
      <p className="mt-2 text-[#475569] text-[14.5px]">Edit landing copy, founder bio, legal pages, emails, and image URLs. Changes apply immediately on next page load.</p>

      <div className="mt-6 dms-card p-3 flex items-center gap-2">
        <Search className="w-4 h-4 text-[#94A3B8] ml-2" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by key (e.g. landing.hero)…" className="dms-input border-0 shadow-none focus:ring-0" data-testid="admin-cms-search" />
      </div>

      <div className="mt-6 space-y-3">
        {loading ? <div className="text-[#64748B]"><Loader2 className="w-4 h-4 animate-spin inline mr-2" />Loading…</div> :
         filtered.map((b) => {
           const draft = drafts[b.key] ?? b.value;
           const dirty = drafts[b.key] !== undefined && drafts[b.key] !== b.value;
           const isLong = (b.value || "").length > 80 || b.key.includes("body") || b.key.includes("html") || b.key.includes("disclaimer") || b.key.includes("terms") || b.key.includes("privacy");
           return (
             <div key={b.key} className="dms-card p-4" data-testid={`cms-block-${b.key}`}>
               <div className="flex items-start justify-between gap-3 flex-wrap">
                 <div className="font-mono text-[12.5px] text-[#1D4E89] flex-1 min-w-[200px]">{b.key}{b.is_overridden && <span className="ml-2 text-[10px] tracking-[0.2em] uppercase font-bold text-[#4FD1C5]">overridden</span>}</div>
                 <div className="flex gap-1.5">
                   {b.is_overridden && <button onClick={() => reset(b.key)} className="text-[12px] inline-flex items-center gap-1 px-2 py-1 rounded hover:bg-[#F1F5F9] text-[#64748B]"><RotateCcw className="w-3 h-3" /> Reset</button>}
                   <button onClick={() => save(b.key)} disabled={!dirty} className="text-[12px] inline-flex items-center gap-1 px-2 py-1 rounded bg-[#0A2342] text-white disabled:opacity-30"><Save className="w-3 h-3" /> Save</button>
                 </div>
               </div>
               {isLong ? (
                 <textarea rows={Math.min(10, Math.max(3, Math.ceil((draft || "").length / 80)))} value={draft || ""} onChange={(e) => setDrafts({ ...drafts, [b.key]: e.target.value })} className="dms-textarea mt-2 text-[13.5px]" />
               ) : (
                 <input value={draft || ""} onChange={(e) => setDrafts({ ...drafts, [b.key]: e.target.value })} className="dms-input mt-2 text-[14px]" />
               )}
             </div>
           );
         })}
      </div>
    </div>
  );
}
